import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { cambiarRouter, cookieGlobalVars, DscMensajeSpinner, GlobalVars, openModalMensaje } from 'src/app/general/variables';
import { LoginMovil } from 'src/app/models/LoginMovil';
import { FurService } from 'src/app/services/fur.service';

@Component({
  selector: 'app-olvido-clave',
  templateUrl: './olvido-clave.component.html',
  styleUrls: ['./olvido-clave.component.css']
})
export class OlvidoClaveComponent implements OnInit {

  strCorreoDen = 'correo@gmail.com';
  data: LoginMovil = null;
  strCodVerif = '';
  boolFlgNuevaClave = false;
  strClave = '';
  strClave2 = '';
  DscMensajeSpinner: string = DscMensajeSpinner;

  constructor(
    protected furService: FurService,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    public router: Router,
  ) {


  }

  ngOnInit() {


    this._cargarDatosLocal();

  }

  _cargarDatosLocal() {

    cookieGlobalVars(8);

    this.data = GlobalVars.objOlvidoClave;

    if (this.data) {

      this.strCorreoDen = this.data.strCorreoDen;

    }


  }

  _continuar() {

    const olvidoClave: LoginMovil = new LoginMovil();
    let numCasoTrx = 0;
    let strNewClave1 = this.strClave;
    let strNewClave2 = this.strClave2;
    let strCodVerificacion = this.strCodVerif;

    this._cargarDatosLocal();

    strNewClave1 = strNewClave1 ? strNewClave1 : '';
    strNewClave2 = strNewClave2 ? strNewClave2 : '';
    strCodVerificacion = strCodVerificacion ? strCodVerificacion : '';

    if (this.boolFlgNuevaClave == true) {

      if (strNewClave1 == '' || strNewClave2 == '') {

        openModalMensaje('Atención de Denuncias', 'Debe ingresar la nueva clave, por favor verifique', this.dialog);

        return;

      }

      if (strNewClave1 != strNewClave2) {

        openModalMensaje('Atención de Denuncias', 'Las claves ingresadas deben coincidir, por favor verifique', this.dialog);

        return;

      }
      numCasoTrx = 2;

    } else {

      if (strCodVerificacion == '') {

        openModalMensaje('Atención de Denuncias', 'Debe ingresar el código de verificación, por favor verifique', this.dialog);

        return;

      }


      numCasoTrx = 1;

    }

    olvidoClave.cfurCodigoBorrador = this.data.cfurCodigoBorrador;
    olvidoClave.strCodVerificacion = strCodVerificacion;
    olvidoClave.cfurClavedenunc = strNewClave1;

    this._olvidoClaveTrx(olvidoClave, numCasoTrx);

  }

  _olvidoClaveTrx(olvidoClave: LoginMovil, numCaso: number) {

    let strDscError1 = '';
    let boolFlgMsgOK = false;

    switch (numCaso) {
      case 1: // CÓDIGO DE VERIFICACIÓN

        strDscError1 = 'El código de verificación ingresado es incorrecto';
        olvidoClave.strFlgOlvidoClave = '02';

        break;
      case 2: // NUEVA CLAVE

        strDscError1 = 'Nueva clave incorrecta';
        olvidoClave.strFlgOlvidoClave = '03';
        boolFlgMsgOK = true;

        break;

      default:
        break;
    }

    this.spinner.show();

    this.furService.obtenerFurPorLoginMovil(olvidoClave).subscribe(

      data => {

        this.spinner.hide();

        if (data == null) {

          openModalMensaje('Atención de Denuncias', strDscError1 + ', por favor verifique', this.dialog);

          return;

        }

        if (boolFlgMsgOK == true) {

          openModalMensaje('Atención de Denuncias', 'Se realizó la modificación de la clave.', this.dialog).afterClosed().subscribe(result => {

            cambiarRouter(this.router, 1);

          });

          return;

        }

        this.boolFlgNuevaClave = true;

      }
      ,
      err => {

        this.spinner.hide();
        console.log(err);

        openModalMensaje('Atención de Denuncias', 'Inconvenientes con el servicio de olvido de clave', this.dialog);

        return;

      }
      );

  }

  _salirFormulario() {

    cambiarRouter(this.router, 1);


  }

}
